import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { editDraft } from '@app/store/transport-layer/form/drafts';

export default function useUpdateDraft(
  options?: UseMutationOptions<
    {
      id: string;
      name: string;
      content: string;
      createdAt: string;
      updatedAt: string;
    },
    Error,
    {
      workspaceId: string;
      data: {
        id: string;
        name: string;
        content: string;
      };
    }
  >
) {
  const queryClient = useQueryClient();

  return useMutation(({ workspaceId, data }) => editDraft(workspaceId, data), {
    ...options,
    onSuccess: (data, variables, ctx) => {
      queryClient.setQueryData(['draft', variables.data.id], {
        id: variables.data.id,
        name: variables.data.name,
        content: variables.data.content,
      });

      options?.onSuccess?.(data, variables, ctx);
    },
  });
}
